/**
 * @tabler/icons-react v2.39.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEyeSearch = createReactComponent("eye-search", "IconEyeSearch", [
  ["path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M12 18c-.328 0 -.652 -.017 -.97 -.05c-3.172 -.332 -5.85 -2.315 -8.03 -5.95c2.4 -4 5.4 -6 9 -6c3.465 0 6.374 1.853 8.727 5.558",
      key: "svg-1"
    }
  ],
  ["path", { d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M20.2 20.2l1.8 1.8", key: "svg-3" }]
]);

export { IconEyeSearch as default };
//# sourceMappingURL=IconEyeSearch.js.map
